<template>
  <card class="ad-listing" style="padding: 10px !important;">
    <el-carousel
      :interval="5000"
      arrow="always"
      indicator-position="none"
      :class="[{ [`carousel-${type}`]: type }]"
    >
      <el-carousel-item
        v-for="(adListing, index) in adListingsFormat"
        :key="index"
      >
    
        <div class="iframe-wrapper" v-if="adListing.listingIframeUrl">
          
          <div
            class="iframe-header"
            :class="$route.path.replace('/producto/', 'product-')"
          >
            <span class="icon-wrapper">
              <!-- <img
                :src="require('@/assets/images/products/' + $route.path.replace('/producto/', '') +'.svg')"
              /> -->
              <img
                :src="
                  require(`../../../assets/images/products/${$route.params.productName}.svg`)
                "
                alt=""
              />
            </span>
            <p>{{ $route.params.productName }}</p>
          </div>
          
          <div class="iframe-content" style="display: flex !important; align-items: center !important; justify-content: center !important;">
            <mq-layout :mq="['laptop', 'desktop','mobile', 'tablet', 'smallLaptop']">
              <iframe
                width="100%"
                height="100%"
                :src="adListing.listingIframeUrl"
                frameborder="0"
                scrolling="no"
              ></iframe>
            </mq-layout>
          </div>
        </div>
        <mq-layout :mq="['laptop', 'desktop']">
          <div class="ad-listing-copy">
            <a
              v-if="adListing.listingProfileUrl"
              :href="adListing.listingProfileUrl"
              target="_blank"
              class="btn-product"
              >Ver perfil</a
            >
            <!-- <p v-if="adListing.listingIframeUrl">
              {{adListing.listingIframeUrl}} en clasificado
              <a
                :href="adListing.listingIframeUrl"
                target="_blank"
              >{{adListing.listingIframeUrl}}</a>
            </p> -->
          </div>
        </mq-layout>
      </el-carousel-item>
    </el-carousel>
  </card>
</template>
<script>
export default {
  name: "ad-listings-yp",
  autoplay: false,
  props: {
    adListings: Array,
    type: String
  },
  data() {
    return {
      adListingsFormat: []
    };
  },
  created: function() {
    const adlistings_1 = [];
    this.adListings &&
      this.adListings.forEach(element => {
        let obj = {
          listingIframeUrl: element
        };
        adlistings_1.push(obj);
      });

    this.adListingsFormat = adlistings_1;
  }
};
</script>
<style lang="scss" scoped>
.website-button {
  margin-top: 20px;
}
.iframe-wrapper {
  width: 100%;
  .iframe-header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 12px;
    justify-content: center;
    background-color: $blueish-gray-100;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    p {
      color: #000;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .icon-wrapper {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      justify-items: center;
      align-content: center;
      background-color: #fff;
      margin-right: 5px;
      box-shadow: 0px 1px 5px rgba(71, 85, 108, 0.1);

      img {
        width: 100%;
      }
    }
  }
  .iframe-content {
    border: 1px solid $blueish-gray-200;
    width: 100%;
    height: 290px;
    overflow: hidden;
    box-sizing: border-box;
    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      height: 290px;
      width: 100%;
      margin: 0 auto;
    }
  }
}
.laptop-viewport {
  width: 100%;
  // height: 260px;
  border: 1px solid;
  border-color: $blueish-gray-200;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0px 0px 0px;
  box-sizing: border-box;
  span.laptop-camera {
    width: 10px;
    height: 10px;
    background-color: $blueish-gray-200;
    display: block;
    border-radius: 20px;
    margin-bottom: 10px;
  }
  .laptop-screen {
    width: 100%;
    height: 100%;
    display: block;
    border: 1px solid;
    border-bottom: none;
    border-color: $blueish-gray-200;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    iframe {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
  }
}

.ad-data-copy {
  display: grid;
  justify-content: space-evenly;
  align-content: center;
  margin-top: 15px;
  flex-direction: column;
  grid-template-columns: 1fr 1fr 1fr;
  .data {
    margin-bottom: 10px;
    &:last-child {
      border-right: 0px;
    }
    h5 {
      color: $highlight-color;
    }
    p {
      font-size: 12px;
    }
  }
}

@include respond-above(sm) {
  .ad-data-copy {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .data {
      border-right: 1px solid #f1f2f3;
      padding: 0px 20px;
      padding-top: 10px;
      padding-bottom: 10px;
      &:last-child {
        border-right: 0px;
      }
    }
  }
}

@include respond-above(md) {
  .laptop-viewport {
    padding: 10px 25px 0px 25px;
  }
  .iframe-wrapper {
    .iframe-content {
      height: 290px;
      div {
        height: 290px;
      }
    }
  }
}

.ad-listing {
  text-align: center;
}
.ad-listing-copy {
  margin-top: 10px;
  p {
    margin-bottom: 5px;
  }
  .btn-product {
    margin-bottom: 5px;
    display: block;
  }
  .product-paginas-amarillas {
    background-color: $pa-color;
    color: #000;
    // box-shadow: 0px 3px 5px 0px $pa-color;
  }
}
</style>

<style lang="scss">
.laptop-viewport {
  width: 100%;
  height: 260px;
  border: 1px solid;
  border-color: $blueish-gray-200;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 25px 0px 25px;
  box-sizing: border-box;
  span.laptop-camera {
    width: 10px;
    height: 10px;
    background-color: $blueish-gray-200;
    display: block;
    border-radius: 20px;
    margin-bottom: 10px;
  }
  .laptop-screen {
    width: 100%;
    height: 100%;
    display: block;
    border: 1px solid;
    border-bottom: none;
    border-color: $blueish-gray-200;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }
}

.ad-listing {
  text-align: center;
}
.ad-listing-copy {
  margin-top: 10px;
  p {
    margin-bottom: 0px;
  }
}
.el-carousel__item {
  padding: 0px;
  box-sizing: border-box;
}
.el-carousel__arrow--left,
.el-carousel__arrow--right {
  background-color: transparent !important;
  i {
    color: $link-color;
  }
}

.el-carousel__arrow--left {
  left: -10px !important;
}
.el-carousel__arrow--right {
  right: -10px !important;
}
.el-carousel__container {
  height: 410px !important;
  // height: 340px !important;
}
</style>